import { render, staticRenderFns } from "./dependencies.vue?vue&type=template&id=b8ad89be&lang=pug"
import script from "./dependencies.vue?vue&type=script&lang=js"
export * from "./dependencies.vue?vue&type=script&lang=js"
import style0 from "./dependencies.vue?vue&type=style&index=0&id=b8ad89be&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports